/**
 * トップページ専用スクリプト（jQuery・Slick 不使用）
 * モーダル・アンカー・タブ・タグ整形のみ。スライダーは slider.js で対応。
 */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  // モーダル開く
  document.querySelectorAll(".js-modalOpen").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      document.body.classList.add("modal-open");
      var targetId = this.getAttribute("data-target");
      if (targetId) {
        var target = document.querySelector(targetId);
        if (target) target.classList.add("open");
      }
    });
  });

  // アンカー（スムーススクロール）
  document.querySelectorAll(".goto").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      var targetId = this.getAttribute("data-target");
      if (!targetId) return;
      var target = document.querySelector(targetId);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });

  // モーダル閉じる
  document.querySelectorAll(".modal__close").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      document.body.classList.remove("modal-open");
      var modal = this.closest(".modal");
      if (modal) modal.classList.remove("open");
    });
  });

  ready(function () {
    // タブ切り替え（requestIdleCallback で遅延）
    function runTabAndContentInit() {
      document.querySelectorAll(".nav-tabs").forEach(function (nav) {
        nav.addEventListener("click", function (e) {
          var link = e.target.closest("a.js-tab");
          if (!link) return;
          e.preventDefault();
          if (link.parentElement.classList.contains("active")) return;
          nav.querySelectorAll(".active").forEach(function (a) {
            a.classList.remove("active");
          });
          link.parentElement.classList.add("active");
          var targetId = link.getAttribute("data-target");
          if (!targetId) return;
          var target = document.querySelector(targetId);
          if (!target) return;
          target.parentElement.querySelectorAll(".tab-panel").forEach(function (p) {
            p.classList.remove("in");
          });
          setTimeout(function () {
            target.parentElement.querySelectorAll(".tab-panel").forEach(function (p) {
              p.classList.remove("active");
            });
          }, 150);
          target.classList.add("active");
          setTimeout(function () {
            target.classList.add("in");
          }, 150);
        });
      });
      document.querySelectorAll(".tabs-content .tab-panel#tab5").forEach(function (p) {
        p.classList.add("active", "in");
      });
    }

    // 導入事例タグ表示（カンマ区切りを span に）
    function runTagsInit() {
      document.querySelectorAll(".slide-data__tags").forEach(function (el) {
        var text = el.textContent || "";
        var html = text.split("、").map(function (item) {
          return "<span>" + item.trim() + "</span>";
        }).join("");
        el.innerHTML = html;
      });
    }

    if (typeof requestIdleCallback !== "undefined") {
      requestIdleCallback(runTabAndContentInit, { timeout: 1500 });
      requestIdleCallback(runTagsInit, { timeout: 1500 });
    } else {
      setTimeout(runTabAndContentInit, 1);
      setTimeout(runTagsInit, 1);
    }
  });
})();
